<div class="h-screen marquee bg-gradient-to-t from-grape-darker via-raspberry-darker to-raspberry-darker">
  <div class="marquee__content">
    <ng-container *ngFor="let review of reviews">
      <ng-container *ngTemplateOutlet="reviewTemplate; context: { $implicit: review }"></ng-container>
    </ng-container>
  </div>

  <!-- repeat the reviews to support our infinite marquee effect -->
  <div class="marquee__content">
    <ng-container *ngFor="let review of reviews" aria-hidden="true">
      <ng-container *ngTemplateOutlet="reviewTemplate; context: { $implicit: review }"></ng-container>
    </ng-container>
  </div>
</div>

<ng-template #reviewTemplate let-review>
  <div class="max-w-sm flex flex-col items-center bg-white rounded-2xl p-4 py-6 shadow-2xl">
    <img [src]="review.image" alt="reviewer" class="w-36 h-36 rounded-full" loading="lazy" />
    <blockquote class="font-bold text-lg text-center m-0 px-20 mt-4">{{ review.review }}</blockquote>
    <div class="mt-4 text-raspberry-darker font-bold">{{ review.name }}</div>
  </div>
</ng-template>
